export default __webpack_public_path__ + "static/media/e.23ac8c08.png";